import { useState, useCallback } from 'react';
import { DropdownMenu } from './DropdownMenu';

/**
 * Custom glass-panel dropdown that replaces native <select>.
 * Fully stylable — no browser default black background or blue hover.
 */
export const GlassSelect = ({ options, value, defaultValue, onChange, disabled, id }) => {
    const isControlled = value !== undefined;
    const [internalValue, setInternalValue] = useState(defaultValue ?? '');
    const currentValue = isControlled ? value : internalValue;

    const selectedOption = options.find(o => o.value === currentValue);
    const displayLabel = selectedOption ? selectedOption.label : (defaultValue || '');

    const handleSelect = useCallback((optionValue) => {
        if (disabled) return;
        if (!isControlled) setInternalValue(optionValue);
        if (onChange) {
            onChange({ target: { value: optionValue } });
        }
    }, [disabled, isControlled, onChange]);

    return (
        <div id={id} className="glass-select-wrapper">
            <DropdownMenu
                disabled={disabled}
                trigger={
                    <button className="glass-select-trigger" disabled={disabled} type="button">
                        <span>{displayLabel}</span>
                    </button>
                }
            >
                {options.map(option => (
                    <button
                        key={option.value}
                        type="button"
                        onClick={() => handleSelect(option.value)}
                        disabled={option.disabled}
                    >
                        <span>{option.label}</span>
                    </button>
                ))}
            </DropdownMenu>
        </div>
    );
};
